import React, { Component } from 'react';
import { delay } from 'lodash';
import PropTypes from 'prop-types';
import Fa from 'react-fontawesome';
import enhanceWithClickOutside from 'react-click-outside';
import CopyToClipboard from 'react-copy-to-clipboard';
import { Button, Tooltip, OverlayTrigger } from 'react-bootstrap';

class CopyButton extends Component {
  constructor() {
    super();
    this.state = {
      copied: false,
    };
    this.handleCopy = this.handleCopy.bind(this);
  }

  handleClickOutside() {
    this.setState({ copied: false });
  }

  handleCopy() {
    this.setState({ copied: true }, () => {
      delay(() => {
        this.setState({ copied: false });
      }, 1000);
    });
  }


  render() {
    const {
      tooltip, data, size, key,
      tooltipPlacement, style,
    } = this.props;
    const { copied } = this.state;

    const btn = !copied ? (
      <CopyToClipboard
        text={data}
        onCopy={this.handleCopy}
      >
        <Button
          type="button"
          bsStyle={style}
          bsSize={size}
        >
          {this.props.children}
        </Button>
      </CopyToClipboard>
    ) : (
      <Button
        type="button"
        disabled
        bsStyle="link"
        bsSize={size}
      >
        <Fa name="check" /> Copied!
      </Button>
    );
    if (tooltip && !copied) {
      const tip = (
        <Tooltip id={`${(key ? `${key}-confirm-tip` : 'confirm-tip')}`}>
          <div>{tooltip}</div>
        </Tooltip>
      );
      return (
        <OverlayTrigger key="button" trigger={['hover', 'focus']} placement={tooltipPlacement} overlay={tip}>
          {btn}
        </OverlayTrigger>
      );
    }
    return btn;
  }
}

CopyButton.propTypes = {
  data: PropTypes.string,
  key: PropTypes.string,
  tooltip: PropTypes.string,
  tooltipPlacement: PropTypes.string,
  size: PropTypes.string,
  style: PropTypes.string,
  children: PropTypes.node,
};
CopyButton.defaultProps = {
  data: null,
  key: null,
  size: 'sm',
  style: 'default',
  tooltipPlacement: 'top',
  tooltip: null,
  children: null,
};

export default enhanceWithClickOutside(CopyButton);
